var $ = jQuery = require('jquery');

window.show_quote_form = function() {
  $.magnificPopup.open({
    mainClass: 'mfp-fade',
    removalDelay: 400,
    overflowY: 'scroll',
    callbacks: {
      close: function () {
        var $scope = angular.element($('.search-block,.stage_teo_main')[0]).scope();
        $scope.quote.popupcar = false;
      }
    },
    items: [
      {
        type: 'inline',
        src: 'footer .quote-form'
      }
    ]
  })
}

window.scrollProperties = function() {
  var prev = current = 0, dir = false;
  window.addEventListener('scroll', function () {
    current = document.documentElement.scrollTop || document.body.parentNode.scrollTop || document.body.scrollTop;
    dir = prev > current;
    prev = current;
  });
  return {
    up: function () {
      return dir;
    },
    pos: function () {
      return current;
    }
  }
}
window.scrol = new scrollProperties();

window.scroll_to_search_form = function(cb) {
  var search_form = $('.search-block');
  $(window).scrollTo(search_form, 500, cb);
}
window.isMobile = function() {
  return document.body.clientWidth < 650;
}

window.isMobileOs = function() {
  return /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(navigator.appVersion);
}




/*****************
 ** WEBPACK FOOTER
 ** ./gulp/assets/javascripts/helpers.js
 ** module id = 7
 ** module chunks = 0
 **/